// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';

export const resetCustomerDetails = () => ({
    data: getDefaultState(),
    type: actions.RESET_CUSTOMER_DETAILS
});



// WEBPACK FOOTER //
// ./src/customer/details/action-creators/reset.js